import React, { useEffect } from "react";
import { navigate } from "gatsby";

import Image from "../image";
// import Stars from "../stars/stars";

import { getLanguageField } from "../../utils/language";
import { toCurrency } from "../../utils/currency";

import provisionalModuleDataBasedOnLanguage from "../../modules/lodging/searchList/provisionalModuleDataBasedOnLanguage";
import * as styles from "./styles.module.scss";

import { getImageDeliveryUrl } from "src/utils/imageDelivery";

const LodgingSliderCell = ({
  marker,
  id,
  selected,
  selectedLanguage,
  setSelectedLodging,
  getLinkToSupplierPage,
  lodgingId,
  isPackage = false
}) => {
  const moduleData = provisionalModuleDataBasedOnLanguage(selectedLanguage);
  useEffect(() => {
    if (selected) {
      const slider = document.getElementsByClassName("lodging-map-slider")[0];
      const element = document.getElementById(id);
      const sliderWidth = slider.clientWidth;
      const cellWidth = element.clientWidth;
      const offsetRight = (sliderWidth / 2) - (cellWidth / 2);
      slider.scrollLeft = element.offsetLeft - offsetRight;
    }
  }, [selected, id]);

  return (
    <div
      className={styles.lodgingSliderCellWrapper}
      id={id}
      onClick={() => selected ? navigate(getLinkToSupplierPage(marker)) : setSelectedLodging(lodgingId)}
      tabIndex={-1}
      onKeyDown={(e) => null}
    >
      <div
        className={`${styles.lodgingSliderCell} ${selected ? styles.selectedCell : ""
          }`}
      >
        <div className={styles.img}>
          <Image
            alt={marker.name}
            src={`https://${getImageDeliveryUrl()}/${marker.images[0]?.image.filename_disk}`}
          />
        </div>
        <div className={styles.info}>
          <span
          >
            {getLanguageField(marker.translations, selectedLanguage, 'name')}
          </span>
          {/* {marker && marker.rating_value && <Stars stars={marker.rating_value} />} */}
          {/* {marker && marker.amenities.length ?
            <div className="flex gap-2 flex-wrap">
              {marker.amenities.map((amenity, idx) => {
                //TODO implement better: for now colors random and max of 2 amenities
                const colorStyle = idx % 2 === 0 ? { background: "#FCF0E0", color: "#E87E00" } : { background: "#E9F4E8", color: "#098A00" }
                if (idx > 1) return;
                return <span className="p-2 flex items-center rounded-2xl" style={colorStyle}>{amenity}</span>
              })}
            </div>
            : null} */}

          {/* <div className={styles.priceInfo}>             */}
          {
            marker.price && !isPackage ?
            <span className="ml-auto flex flex-col text-xs items-end text-[#75757D] mb-[10px]">
              {moduleData.from}
              <span className="text-xl semiboldFontFamily text-black ">
                {toCurrency({
                  value: marker.price?.amount,
                  valueCurrency: marker.price?.currency
                })}
              </span>
            </span>
            : null
          }
          {/* </div> */}
        </div>
      </div>
    </div>
  );
};


export default LodgingSliderCell;